export const CAMPAIGN_CARD_DIAL_SIZE = 140;
